<template>
    <div>
        <header-page></header-page>
        <full-page :options="options" id="fullpage">
            <div class="section" id="section0">
                <div class="slide" id="buffetP">
                </div>

            </div>
            <div class="TitleBottom"><a
                    @click="$vuetify.goTo('#welcome',{ duration:1000, offset:0, easing:'easeInOutCubic'})">
                <h1>
                    <v-icon :size="screenwidth" color="white">mdi-chevron-down</v-icon>
                    Buffets froids ou chauds
                </h1>
            </a></div>
        </full-page>
        <div>
            <div class="backgroundGreen" id="welcome">
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-8 col-lg-8" style="background:#b3a3a4;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h2 class="display-5 bottomH2">Pour des repas sans contrainte</h2>
                                        <p>
                                            Croustillance vous propose plusieurs <b>formules de buffets froids ou
                                            chauds</b>, à des prix très raisonnables, pour toutes vos réceptions privées
                                            à partir de 20 personnes : anniversaires, départs en retraite, repas de
                                            famille, soirées entre amis, baptêmes, communions, etc.
                                        </p>
                                        <p>
                                            Vous voulez organiser un moment convivial et chaleureux avec vos proches,
                                            sans vous noyer dans les préparatifs ? Le buffet présente trois avantages
                                            essentiels :
                                        </p>
                                        <p class="pAlpha">
                                        <ul>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Vous profitez d’un <b>vrai repas pris à table</b> avec ceux que vous
                                                aimez. Vous échangez avec eux en toute sérénité, puisqu’il faut compter
                                                au moins 1 h 30 pour un buffet.
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Vous échappez au formalisme et aux contraintes de service du repas assis
                                                traditionnel, puisque vos invités font leur choix à la table-buffet en
                                                toute liberté.

                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Vous êtes sûr de faire plaisir à vos convives, en respectant les goûts
                                                et l'appétit de chacun. Nos buffets comportent une douzaine de plats
                                                différents au minimum… et nous pouvons en proposer bien plus !
                                            </li>
                                        </ul>
                                        </p>
                                        <p>À noter : nous pouvons également nous occuper si vous le souhaitez de la
                                            vaisselle, du nappage et du mobilier.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/buffets-particuliers/buffet-vegetarien.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6 titleSpacer" style="background-color: #7d2c6fb3;">Nos
                                            formules buffets froids</h3>
                                        <p>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/buffet-moselle.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le buffet froid MOSELLE</span>
                                            </a>
                                        </div>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/buffet-chatellois.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le buffet froid CHATELLOIS</span>
                                            </a>
                                        </div>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/buffet-chateau.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le buffet froid DU CHATEAU</span>
                                            </a>
                                        </div>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/buffet-croustillance.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le buffet froid CROUSTILLANCE</span>
                                            </a>
                                        </div>
                                    </div><br>
                                    <h3 class="display-6 titleSpacer" style="background-color: #7d2c6fb3;">Formules barbecue et cochon grillé</h3>
                                    <p>
                                    <div class="btns-action sr-up-td3 text-primary">
                                        <a href="pdf/formule-barbecue.pdf" target="_blank"
                                           class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                            <span class="text">Découvrir la formule BARBECUE</span>
                                        </a>
                                    </div>
                                    <div class="btns-action sr-up-td3 text-primary">
                                        <a href="pdf/formule-cochon.pdf" target="_blank"
                                           class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                            <span class="text">Découvrir la formule COCHON GRILLÉ</span>
                                        </a>
                                    </div>
                                    <div class="btns-action sr-up-td3 text-primary">
                                        <a href="pdf/formule-buffet-cochon.pdf" target="_blank"
                                           class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                            <span class="text">Découvrir la formule BUFFET & COCHON GRILLÉ</span>
                                        </a>
                                    </div>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="media-row">
                <div class="row backgroundGreen">
                    <div class="col-12 col-md-4 col-lg-4" style="background:#a7bd1d;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 style="font-size:35px;font-family: 'Nunito', sans-serif;font-weight: bold">
                                        Du classique buffet champêtre à des compositions plus raffinées,
                                        Croustillance saura vous conseiller la formule la plus adaptée à vos envies
                                        et à votre budget.</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('img/buffets-particuliers/buffet-thaon-les-vosges.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/buffets-particuliers/buffet-thaon-les-vosges.jpg"
                                     alt="Buffet à la Rotonde Thaon les Vosges"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/buffets-particuliers/buffet-thaon-les-vosges.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                            <div class="media-body align-top">
                                <div class="desc">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-color: #99b7d0;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">Une formule décontractée</h3>
                                    <p>
                                        Un buffet, c’est aussi l’occasion de papoter avec tous les invités, au moment où
                                        vous garnissez votre assiette.
                                    </p>
                                    <br>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="media-row">
                <div class="row backgroundGreen">
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('img/buffets-particuliers/chinois.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/buffets-particuliers/chinois.jpg" alt="Sushis"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/buffets-particuliers/chinois.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                            <div class="media-body align-top">
                                <div class="desc">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"  style="background:#822343;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">Chacun cherche son plat</h3>
                                    <p>
                                        Lors d’un buffet, les convives optent pour leurs mets préférés… A table, vous ne ferez que des heureux !
                                    </p><br><br>
                                    <h3 class="display-6">Vous préférez du sur-mesure ?</h3>
                                    <p>
                                        L’équipe de Croustillance est à votre écoute, pour toutes vos demandes de buffets personnalisés.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('img/buffets-particuliers/sandwichs.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/buffets-particuliers/sandwichs.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/buffets-particuliers/sandwichs.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                            <div class="media-body align-top">
                                <div class="desc">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-page></footer-page>
    </div>
</template>

<script>
    import HeaderPage from './headerPage'
    import FooterPage from './footerPage'

    export default {
        name: 'buffetPar',
        components: {
            HeaderPage,
            FooterPage
        },
        data() {
            return {
                options: {
                    licenseKey: 'A32C7F42-F0FE4A04-AAB7E182-AB1F9C8B',
                    navigation: false,
                    scrollBar: true,
                    autoScrolling: false,
                    fitToSection: false
                }
            }
        },
        methods: {
            afterLoad() {
                console.log('After load')
            },
        },
        computed: {
            screenwidth() {
                if (screen.width > 400) {
                    return 70
                } else {
                    return 30
                }
            }
        },
        created() {
            document.getElementsByTagName('meta')["description"].content = "Croustillance vous propose des formules de buffets froids ou chauds, à des prix très raisonnables, pour vos réceptions privées à partir de 20 personnes.";
            document.title = "Buffets pour réceptions privées | Traiteur Croustillance";
        }
    }
</script>

<style>
    #buffetP {
        background: url('/img/buffets-particuliers/buffet-traiteur.jpg') no-repeat center center;
        padding: 0 0 0 0;
        background-size: cover;
    }

    .titleSpacer {
        padding: 10px;
        width: max-content;
    }
</style>